import { useAuth0 } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { Spinner, Container, Alert } from 'react-bootstrap';
import { useUserPermissions } from '../../contexts/UserPermissionsContext';

function EditorRoute({ children }) {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const {
    userPermissions,
    loading: permissionsLoading,
    isEditor,
    isPending,
    isSuspended,
  } = useUserPermissions();

  if (authLoading || permissionsLoading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Loading...</p>
      </Container>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (isPending) {
    return (
      <Container className="mt-5">
        <Alert variant="warning">
          <Alert.Heading><><i className="bi bi-hourglass-split me-1"></i>Account Pending Approval</></Alert.Heading>
          <p>Your account is pending approval by an administrator.</p>
          <p>
            You will be able to access this page once your account has been
            activated.
          </p>
          <hr />
          <p className="mb-0">
            Your Email: <strong>{userPermissions?.email}</strong>
          </p>
        </Alert>
      </Container>
    );
  }

  if (isSuspended) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading><><i className="bi bi-x-circle-fill me-1"></i>Account Suspended</></Alert.Heading>
          <p>Your account has been suspended.</p>
          <p>Please contact an administrator for more information.</p>
        </Alert>
      </Container>
    );
  }

  if (!isEditor) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">
          <Alert.Heading><><i className="bi bi-lock-fill me-1"></i>Access Denied</></Alert.Heading>
          <p>You don't have permission to access this page.</p>
          <p>Only editors and administrators can register new records.</p>
          <hr />
          <p className="mb-0">
            Your role: <strong>{userPermissions?.access_type || 'None'}</strong>
          </p>
        </Alert>
      </Container>
    );
  }

  return children;
}

export default EditorRoute;
